import React from "react";
import { Card, CardContent } from "@mui/material";
import DocumentUpload from "../components/DocumentUpload";

const Document = () => {

  return (
    
      <Card>
        <CardContent>
           <DocumentUpload opeType={1}/>        
        </CardContent>
      </Card>
   
  );
};

export default Document;


